var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.913,
    height: 22.913,
    viewBox: "0 0 22.913 22.913",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29981",
    "data-name": "Group 29981",
    transform: "translate(-28.487 -459.764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_203_1",
    "data-name": "Component 203 \\u2013 1",
    transform: "translate(28.887 460.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49961",
    "data-name": "Path 49961",
    d: "M14.057,25.113A11.057,11.057,0,1,1,25.113,14.057,11.044,11.044,0,0,1,14.057,25.113Zm0-21.172A10.116,10.116,0,1,0,24.172,14.057,10.13,10.13,0,0,0,14.057,3.941Z",
    transform: "translate(-3 -3)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49962",
    "data-name": "Path 49962",
    d: "M38.895,35.2a.472.472,0,0,1-.47-.47V33.2a.481.481,0,0,1,.376-.47c.094-.024,2.352-.47,2.517-2.47a2.1,2.1,0,0,0-1.6-2.282,2.476,2.476,0,0,0-3.129,1.482.48.48,0,0,1-.612.282.461.461,0,0,1-.282-.612,3.464,3.464,0,0,1,4.258-2.07,3.01,3.01,0,0,1,2.282,3.2v.047a3.834,3.834,0,0,1-2.917,3.246V34.7A.417.417,0,0,1,38.895,35.2Z",
    transform: "translate(-27.979 -21.295)",
    fill: "#fff",
    stroke: "#feffff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1095",
    "data-name": "Ellipse 1095",
    cx: 1.059,
    cy: 1.059,
    r: 1.059,
    transform: "translate(9.951 15.455)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.8
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-Icon.e1d0f0b43cbb773e6a2f06f547ac0a1b.svg";
export { ForwardRef as ReactComponent };